const routeUserInfo = [
  {
    path: '/group',
    name: 'GroupPage',
    component: () => import('@/pages/group/GroupPage'),
    meta: {
      layout: 'HomeLayout',
    },
  },
];

export default routeUserInfo;
